<script setup lang="ts">
import { TotalByStatus } from '@/@types/order'
import { Workshop } from '@/@types/workshop'
import Image from '@/assets/show/image.webp'
import { TotalsByStatus } from '@/components/shared/admin/orders/CardStatus'
import Button from '@/components/ui/button/Button.vue'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card'
import { formatDateFull } from '@/helpers/format-date'
import { Link } from '@inertiajs/vue3'
import { Calendar } from 'lucide-vue-next'

defineProps<{
    workshop: Workshop
    orders_by_status?: TotalByStatus
}>()
</script>

<template>
    <Card class="divide-y p-6">
        <CardHeader>
            <div class="flex flex-col justify-between gap-4 md:flex-row">
                <div class="flex items-center gap-4">
                    <img :src="Image" class="h-26 w-26 rounded-full" />
                    <div class="flex flex-col">
                        <CardTitle class="text-2xl text-gray-800">{{ workshop.description }}</CardTitle>
                        <CardDescription class="text-base text-gray-600">
                            <div class="flex gap-2">
                                <Calendar />
                                {{ formatDateFull(workshop.start, $i18n.locale) }}
                                -
                                {{ formatDateFull(workshop.end, $i18n.locale) }}
                            </div>
                        </CardDescription>
                    </div>
                </div>
                <div class="flex gap-6">
                    <Button :as="Link" :href="`/admin/workshops/${workshop.id}/orders/new`">{{ $t('Register order') }}</Button>
                </div>
            </div>
        </CardHeader>
        <CardContent class="grid gap-5 overflow-auto py-8 font-sans md:grid-cols-3 lg:grid-cols-5">
            <TotalsByStatus v-for="(value, status) in orders_by_status" :variant="status" :status="status" :value="value" :key="status" />
        </CardContent>
    </Card>
</template>
